/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeePersonalDetails } from './EmployeePersonalDetails';
import {
    EmployeePersonalDetailsFromJSON,
    EmployeePersonalDetailsFromJSONTyped,
    EmployeePersonalDetailsToJSON,
    EmployeePersonalDetailsToJSONTyped,
} from './EmployeePersonalDetails';

/**
 * 
 * @export
 * @interface ShowEmployeePersonalDetailResponse
 */
export interface ShowEmployeePersonalDetailResponse {
    /**
     * 
     * @type {EmployeePersonalDetails}
     * @memberof ShowEmployeePersonalDetailResponse
     */
    data: EmployeePersonalDetails;
}

/**
 * Check if a given object implements the ShowEmployeePersonalDetailResponse interface.
 */
export function instanceOfShowEmployeePersonalDetailResponse(value: object): value is ShowEmployeePersonalDetailResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowEmployeePersonalDetailResponseFromJSON(json: any): ShowEmployeePersonalDetailResponse {
    return ShowEmployeePersonalDetailResponseFromJSONTyped(json, false);
}

export function ShowEmployeePersonalDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowEmployeePersonalDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeePersonalDetailsFromJSON(json['data']),
    };
}

  export function ShowEmployeePersonalDetailResponseToJSON(json: any): ShowEmployeePersonalDetailResponse {
      return ShowEmployeePersonalDetailResponseToJSONTyped(json, false);
  }

  export function ShowEmployeePersonalDetailResponseToJSONTyped(value?: ShowEmployeePersonalDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeePersonalDetailsToJSON(value['data']),
    };
}

